import { render, staticRenderFns } from "./Brand_Header.vue?vue&type=template&id=c4271e8c&scoped=true&"
import script from "./Brand_Header.vue?vue&type=script&lang=js&"
export * from "./Brand_Header.vue?vue&type=script&lang=js&"
import style0 from "./Brand_Header.vue?vue&type=style&index=0&id=c4271e8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4271e8c",
  null
  
)

export default component.exports